import { render } from "./OrdersHub.vue?vue&type=template&id=691bc605&scoped=true"
import script from "./OrdersHub.vue?vue&type=script&lang=js"
export * from "./OrdersHub.vue?vue&type=script&lang=js"

import "./OrdersHub.vue?vue&type=style&index=0&id=691bc605&lang=scss&scoped=true"

import exportComponent from "/Users/fabiankala/Documents/projects/jan-art/jan-art-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691bc605"]])

export default __exports__